import { useScreenClass as swanScreenClass } from "@vp/swan";

type FontSizes = -2 | -1 | 1 | 2 | 3 | 4;
type TextAlignment = "left" | "center";
type VerticalMarginSizes = 0 | 2 | 3 | 4 | 5 | 6 | 8 | 9 | 12 | 7 ;
type HorizontalMarginSizes = 0 | 2 | 5 | 7;

interface FontSize {
  large: FontSizes;
  medium: FontSizes;
  small: FontSizes;
}

interface Margins {
  page: {
    horizontal: HorizontalMarginSizes;
  };
  heading: {
    reset: {
      top: VerticalMarginSizes;
    };
    sign: {
      bottom: VerticalMarginSizes;
    };
  };
  content: {
    vertical: VerticalMarginSizes;
    withError: VerticalMarginSizes;
  };
  horizontalDivider: {
    socialLoginDividerTop: VerticalMarginSizes;
    guestCheckoutDividerTop: VerticalMarginSizes;
  };
  logo: {
    top: VerticalMarginSizes;
    left: HorizontalMarginSizes;
    bottom: VerticalMarginSizes;
  };
  back: {
    left: HorizontalMarginSizes;
    bottom: VerticalMarginSizes;
  };
  notification: {
    horizontal: HorizontalMarginSizes;
  };
}

export interface ScreenClassInfo {
  screenSize: string;
  fontSize: FontSize;
  textAlign: TextAlignment;
  margins: Margins;
  isMobile: boolean;
  isSmallScreen: boolean;
  isDesktop: boolean;
  isMediumScreen: boolean;
}

export default function useScreenClass (): ScreenClassInfo {
  const screenSize = swanScreenClass();
  const isMobile = screenSize === "xs";
  const isSmallScreen = screenSize === "sm";
  const isMediumScreen = screenSize === "md";
  const isDesktop = screenSize === "lg" || screenSize === "xl";

  const fontSize: FontSize = {
    large: 4,
    medium: 3,
    small: 2
  };

  const textAlign = isMobile ? "left" : "center";

  const margins: Margins = {
    page: {
      horizontal: isMobile ? 2 : 0
    },
    heading: {
      reset: {
        top: isMobile ? 0 : 0
      },
      sign: {
        bottom: isMobile ? 4 : 4
      }
    },
    content: {
      vertical: isMobile ? 8 : 9,
      withError: isMobile ? 4 : 4
    },
    horizontalDivider: {
      socialLoginDividerTop: 8,
      guestCheckoutDividerTop: 4
    },
    logo: {
      top: isMobile ? 3 : 4,
      left: isMobile ? 0 : 5,
      bottom: isMobile ? 0 : 4
    },
    back: {
      left: isMobile ? 0 : 5,
      bottom: isMobile ? 5 : 0
    },
    notification: {
      horizontal: isMobile ? 2 : 7
    }
  };

  return {
    screenSize,
    fontSize,
    textAlign,
    margins,
    isMobile,
    isSmallScreen,
    isDesktop,
    isMediumScreen
  };
}
